import api from '../utils/baseUrl';
import { CampaignLinkRequestObject } from '../utils/types';

type CampaignLinkRequestStatus = 'pending' | 'approved' | 'rejected';

class CampaignLinkRequestService {
    async getAllRequests(params?: {
        status?: CampaignLinkRequestStatus;
        campaignId?: string;
    }) {
        return await api.get<{ requests: CampaignLinkRequestObject[] }>('/api/campaignLinkRequests', { params });
    }

    async getRequestById(requestId: string) {
        return await api.get<{ request: CampaignLinkRequestObject }>(`/api/campaignLinkRequests/${requestId}`);
    }

    async approveRequest(requestId: string) {
        return await api.post(`/api/campaignLinkRequests/${requestId}/approve`);
    }

    async rejectRequest(
        requestId: string,
        payload?: { rejectionReason?: string }
    ) {
        return await api.post(
            `/api/campaignLinkRequests/${requestId}/reject`,
            payload || {}
        );
    }
}

export default new CampaignLinkRequestService();
